import React from "react";

const ICON = {
  width: "109",
  height: "109",
  colors: {
    company: "#87D72A",
    candidate: "#0D7AB6",
  },
};

const IconSuccess = ({ iconType }) => {
  return iconType !== "both" ? (
    <svg width={109} height={109} fill="none">
      <g
        fill={
          iconType === "candidate" ? ICON.colors.candidate : ICON.colors.company
        }
      >
        <path d="M33.002 44.778c-1.507-1.643-4.108-1.78-5.752-.274-1.643 1.506-1.78 4.108-.274 5.751l20.678 22.458c.821.821 1.78 1.369 2.875 1.369h.137c1.096 0 2.19-.41 2.876-1.233l52.309-52.172c1.643-1.643 1.643-4.245 0-5.751-1.643-1.643-4.245-1.643-5.751 0l-49.297 49.16-17.801-19.308z" />
        <path d="M104.892 50.392c-2.328 0-4.108 1.78-4.108 4.108 0 25.47-20.814 46.284-46.284 46.284S8.216 79.97 8.216 54.5 29.03 8.216 54.5 8.216c2.328 0 4.108-1.78 4.108-4.108C58.608 1.78 56.828 0 54.5 0 24.511 0 0 24.511 0 54.5 0 84.49 24.511 109 54.5 109c29.99 0 54.5-24.51 54.5-54.5 0-2.328-1.78-4.108-4.108-4.108z" />
      </g>
      <defs>
        <clipPath id="prefix__clip0">
          <path fill="#fff" d="M0 0h109v109H0z" />
        </clipPath>
      </defs>
    </svg>
  ) : (
    <svg width={124} height={89} fill="none">
      <path
        d="M103.964 1.005L37.487 18.817a3.881 3.881 0 00-2.744 4.753L48.67 75.552a3.881 3.881 0 004.754 2.745l66.477-17.813a3.88 3.88 0 002.744-4.753L108.717 3.749a3.88 3.88 0 00-4.753-2.744z"
        fill="#FFD860"
      />
      <path
        d="M108.718 3.749l13.928 51.982a3.881 3.881 0 01-2.744 4.753l-32.776 8.782-15.938-59.48 32.777-8.781a3.883 3.883 0 014.753 2.744z"
        fill="#FFCA28"
      />
      <path
        d="M108.178 2.57a3.882 3.882 0 00-4.214-1.565L37.487 18.817a3.88 3.88 0 00-.5 7.326L77.44 43.16a3.88 3.88 0 004.622-1.266l26.024-34.83a3.88 3.88 0 00.092-4.494z"
        fill="#FAD051"
      />
      <path
        d="M108.088 7.065l-26.025 34.83a3.882 3.882 0 01-1.903 1.375L71.19 9.787l32.776-8.783a3.88 3.88 0 014.123 6.06z"
        fill="#FFC000"
      />
      <path
        d="M21.896 39.602l-5.998 1.607a3.881 3.881 0 01-2.01-7.497l5.999-1.607a3.881 3.881 0 012.009 7.497zM28.468 72.127L16.472 75.34a3.881 3.881 0 01-2.009-7.497l11.996-3.215a3.88 3.88 0 112.009 7.498zM48.919 45.486a3.882 3.882 0 01-2.745 4.753l-21.992 5.893a3.882 3.882 0 01-4.753-2.744 3.882 3.882 0 012.744-4.753l21.993-5.893a3.882 3.882 0 014.753 2.744z"
        fill="#CECECE"
      />
      <path
        d="M48.919 45.486a3.882 3.882 0 01-2.744 4.753l-4 1.072-2.008-7.498 3.999-1.071a3.882 3.882 0 014.753 2.744z"
        fill="#fff"
      />
    </svg>
  );
};
export default IconSuccess;
